import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../../components/ui/PageWrapper';
import FadeUp from '../../components/ui/FadeUp';
import CTASection from '../../components/sections/CTASection';

const industrialTypes = [
  { icon: '🏭', name: 'Factories & Manufacturing Units' },
  { icon: '📦', name: 'Warehouses & Godowns' },
  { icon: '📐', name: 'Industrial Plots' },
  { icon: '⚙️', name: 'Production Facilities' },
  { icon: '🌿', name: 'Biomass, Processing & Manufacturing Plants' },
];

export default function Industrial() {
  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 50% 50%, rgba(232,135,26,0.05) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">Services / Industrial</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}>Industrial Vastu</h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 560, lineHeight: 1.8 }}>
              Optimise your factory, warehouse, or industrial unit for efficiency, productivity, and worker well-being.
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <div className="industrial-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64 }}>
            <div>
              <FadeUp>
                <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 26, marginBottom: 20 }}>
                  Industrial Properties We Serve
                </h2>
                <p style={{ fontSize: 15, lineHeight: 1.9, opacity: 0.7, marginBottom: 24 }}>
                  Industrial units are complex energy systems where the placement of machinery, raw materials, finished goods, and human workspaces all interact. With first-hand experience in the biomass briquettes and pellets industry, we understand the unique challenges of manufacturing environments.
                </p>
                <div style={{ display: 'grid', gap: 16, marginBottom: 32 }}>
                  {industrialTypes.map((item, i) => (
                    <div key={i} style={{
                      background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.1)',
                      borderRadius: 10, padding: '16px 20px', display: 'flex', gap: 12, alignItems: 'center'
                    }}>
                      <span style={{ fontSize: 24 }}>{item.icon}</span>
                      <span style={{ fontSize: 14, opacity: 0.8 }}>{item.name}</span>
                    </div>
                  ))}
                </div>
              </FadeUp>
            </div>
            <div>
              <FadeUp delay={0.2}>
                <div style={{ background: 'rgba(232,135,26,0.04)', border: '1px solid rgba(232,135,26,0.15)', borderRadius: 12, padding: 28, marginBottom: 24 }}>
                  <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, color: '#E8871A', marginBottom: 16 }}>
                    What We Analyse
                  </h3>
                  {['Factory gate & entrance direction', 'Machinery & equipment placement', 'Raw material storage zones', 'Finished goods & dispatch area', 'Worker rest & canteen areas', 'Administrative block placement', 'Water & fire element zones', 'Production flow optimization'].map((item, i) => (
                    <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                      <span style={{ color: '#E8871A' }}>✦</span>
                      <span style={{ fontSize: 14, opacity: 0.75 }}>{item}</span>
                    </div>
                  ))}
                </div>
                <Link to="/contact" className="btn-primary" style={{ display: 'block', textAlign: 'center' }}>
                  Book Industrial Consultation
                </Link>
              </FadeUp>
            </div>
          </div>
        </div>
      </section>

      <CTASection />

      <style>{`
        @media (max-width: 1024px) {
          .industrial-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
        @media (max-width: 768px) {
          .industrial-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
      `}</style>
    </PageWrapper>
  );
}
